"use client";
import * as React from "react";
const SvgUnfoldMoreRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 10 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5 2.83 7.46 5.3a1 1 0 1 0 1.41-1.4L5.7.7a1 1 0 0 0-1.41 0L1.12 3.88A1 1 0 1 0 2.53 5.3zm0 10.34-2.46-2.46a1 1 0 1 0-1.41 1.41L4.3 15.3a1 1 0 0 0 1.41 0l3.17-3.17a1 1 0 1 0-1.41-1.4z" }));
export {
  SvgUnfoldMoreRound as default
};
